<template>
  <div class="activity-container">
    <div class="content-title">活动管理</div>
    <div class="content-item">
      <OrganizationTree @nodeClick="nodeClick"></OrganizationTree>
      <div class="content-right">
        <div class="right-title">活动</div>
        <div class="query">
          <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
        </div>
        <MyTable :table-options="tableOptions" border max-height="60vh">
          <template #qrCode="{ row }">
            <vue-qr v-if="row.id" :margin="0" :size="400" style="cursor: pointer;width: 40px;" :text="row.id" :callback="(url) => { row.previewQrUrl = url }" @click="row.qrCodeVisible = true"></vue-qr>
            <Dialog width="400" v-model="row.qrCodeVisible" title="二维码预览" top="15vh">
              <img :src="row.previewQrUrl" alt="Preview Image" style="width: 100%" />
            </Dialog>
          </template>
          <template #isActive="{ row }">
            <el-switch v-model="row.isActive" @change="click_switch(row)"></el-switch>
          </template>
          <template #handler="{ row }">
            <MyButton link icon="View" @click="click_view(row)">查看人员</MyButton>
          </template>
        </MyTable>
      </div>
    </div>
    <MyPagination :params="paginationParams" :total="total" @get-list="getActivityList" ref="paginationRef" />

    <!-- 新增活动 -->
    <Dialog width="30%" v-model="dialogVisible" title="新增活动" top="5vh" @closed="formRef.resetFields()">
      <el-form ref="formRef" :model="formData" class="myform" label-width="auto">
        <el-form-item label="活动名称:" prop="name" :rules="[{ required: true, message: '请输入活动名称', trigger: 'blur' }]">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="创建日期:" prop="startDate" :rules="[{ required: true, message: '请选择创建日期', trigger: 'blur' }]">
          <el-date-picker v-model="formData.startDate" type="date" value-format="YYYY-MM-DD"></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="所属单位:" prop="organizationId" :rules="[{ required: true, message: '请选择所属单位', trigger: 'change' }]">
          <el-select v-model="formData.organizationId" placeholder="">
            <el-option v-for="item in unitList" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="所属单位:" prop="organizationId">
          <el-input v-model="formData.organizationName" readonly placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <div class="submit-buttons">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button @click="click_confirm">确定</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import OrganizationTree from "@/components/Common/OrganizationTree.vue";
import activityApi from "@/api/activity";
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { dayjs } from "element-plus";
import organizationApi from "@/api/organization";

// const unitList = ref([]);
// const getUnitList = () => {
//   organizationApi.getUnitList({
//     SkipCount: 0,
//     MaxResultCount: 1000,
//   }).then((res) => {
//     unitList.value = res.data.items
//   })
// }
// getUnitList();

const currentUnit = ref({});
const nodeClick = (data) => {
  currentUnit.value = data;
  paginationParams.OrganizationId = data.id;
}

const queryForm = reactive({
  itemList: [
    {
      type: "Input",
      label: "活动名称:",
      prop: "Name",
      attrs: {
        placeholder: "请输入关键词",
      },
    },
    {
      type: "Date",
      label: "日期:",
      prop: "CreationTime",
      attrs: {
        placeholder: "请选择",
        valueFormat: "YYYY-MM-DD",
      },
    },
    [
      {
        type: "Button",
        value: "查询",
        attrs: {
          icon: "Search",
        },
        events: {
          click(formData) {
            Object.assign(paginationParams, formData);
          },
        },
      },
      {
        type: "Button",
        value: "新建活动",
        attrs: {
          icon: "Plus",
        },
        events: {
          click() {
            if(!currentUnit.value?.id){
              return ElMessage.warning("请先选择组织");
            }
            formData.organizationName = currentUnit.value.name;
            dialogVisible.value = true;
          },
        },
      },
    ]
  ],
});

const tableOptions = reactive({
  colList: [
    { label: "序号", type: "index", width: 60 },
    { label: "活动名称", prop: "name" },
    { label: "创建日期", prop: "startDate" },
    { label: "二维码", type: "slot", slot_name: "qrCode"},
    { label: "是否启动", type: "slot", slot_name: "isActive" },
    { label: "操作", type: "slot", slot_name: "handler", minWidth: 150 },
  ],
  tableData: [],
});

// 分页
const paginationParams = reactive({
  OrganizationId: "",
  Name: "",
  CreationTime: "",
})
const paginationRef = ref(null);
const total = ref(0);
const getActivityList = (params = paginationRef.value.getList_params) => {
  if(!params.OrganizationId){
    return;
  }
  activityApi.getActivityList(params).then((res) => {
    total.value = res.data.totalCount;
    tableOptions.tableData = res.data.items.map(item=>{
      item.startDate = dayjs(item.startDate).format("YYYY-MM-DD");
      return item;
    });
  })
}

const dialogVisible = ref(false);
const formData = reactive({
  name: "",
  startDate: "",
  organizationId: "",
  organizationName: "",
})
const formRef = ref(null);
const click_confirm = () => {
  formRef.value.validate((valid) => {
    if (valid) {
      formData.organizationId = currentUnit.value.id;
      activityApi.addActivity(formData).then(() => {
        ElMessage.success("添加成功");
        dialogVisible.value = false;
        getActivityList();
      })
    }
  })
}

const click_switch = (row) => {
  activityApi.editActivity(row).then((res) => {
    ElMessage.success("操作成功");
  })
}
</script>

<style lang="scss" scoped>
.content-item{
  display: flex;
  min-height: 60vh;
  .content-right {
    flex: 1;
    overflow: hidden;
    .right-title {
      background: #134e92;
      height: 40px;
      line-height: 40px ;
      color: #66baec;
      display: flex;
      justify-content: space-between;
      padding-left: 20px;
    }
    .query {
      background: #03386a;
      padding: 0 20px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #66baec;
      .search-form {
        padding-top: 20px;
      }
    }
  }
}
.myform{
  padding: 20px 40px;
  :deep(){
    .el-input,.el-date-editor{
      width: 360px;
    }
  }
}
</style>